import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import * as homeActions from '../../features/home/redux/actions';
import { REST_API, BelongsToReferenceField } from 'drapcode-constant';
import RefFieldsOptionSelect from '../data-connector/RefFieldsOptionSelect';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { apiTypeImages, snakeCaseToTitleCase } from '../../common/utils/api_utils';
import { flattenObject } from '../../common/utils/jsonUtils';
import { iconForField } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { filters } from '../data-connector/connectorUtils';

export class ReponseDataKeyMappingToUserField extends Component {
  static propTypes = {};
  state = {
    selectedCollection: null,
  };

  componentDidMount() {
    const { collections } = this.props.home;
    const selectedCollection = collections.find((collection) => {
      return collection.collectionName === 'user';
    });
    this.setState({ selectedCollection });
  }

  collectionsOptions = () => {
    const { collections, inMemoryCollections } = this.props.home;
    let collectionsToSelect = [];
    if (collections && collections.length > 0) {
      collectionsToSelect = collections.map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }

    return collectionsToSelect;
  };

  handleSelectedMapping = (evt) => {
    this.props.handleChange('currentUserSelectedMapping', {
      ...this.props.selectedMapping,
      [evt.target.name]: evt.target.value,
    });
  };

  handleSelectedMappingForReferenceField = (name, value) => {
    this.props.handleChange('currentUserSelectedMapping', {
      ...this.props.selectedMapping,
      [name]: value,
    });
  };

  createApiSelect = (name, uniqueKeys) => {
    return (
      <div className="row align-middle">
        <div className="col-md-5 col-lg-5 col-sm-5 text-center">
          <select
            className="form-control form-control-sm custom-select-sm"
            name={name}
            value={this.props.selectedMapping[name]}
            onChange={this.handleSelectedMapping}
          >
            <option value="">Select Key</option>
            {uniqueKeys.map((field) => (
              <option key={field} value={field}>
                {field}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-1 col-lg-1 p-0 text-center mt-1">or</div>
        <div className="col-md-6 col-lg-6 col-sm-6 text-center">
          <input
            name={name}
            value={this.props.selectedMapping[name]}
            onChange={this.handleSelectedMapping}
            className="form-control form-control-sm"
          />
        </div>
      </div>
    );
  };

  showRestApiField = (name) => {
    //TODO:responseData will be passed to this
    const { responseData } = this.props;
    let flattenObjectKeys = [];
    if (responseData) {
      const dataToProcess = this.state.itemsPath
        ? _.get(responseData[0], this.state.itemsPath)
        : responseData;
      const objectWithAllKeys =
        dataToProcess && Array.isArray(dataToProcess) ? Object.assign({}, ...dataToProcess) : {};
      flattenObjectKeys = Object.keys(flattenObject(objectWithAllKeys));
    }
    return this.createApiSelect(name, flattenObjectKeys);
  };

  filterAndShow = (field) => {
    const { projectId, selectedMapping, home, connectorType } = this.props;
    const { selectedCollection } = this.state;
    if (filters.includes(field.fieldName)) {
      return '';
    }
    let flattenObjectKeys = [];
    const { fields } = selectedCollection ? selectedCollection : '';
    const currentField = fields && fields.find((e) => e.fieldName === field.fieldName);
    if (currentField && BelongsToReferenceField.includes(currentField.type)) {
      return (
        <Accordion key={field.fieldName} allowZeroExpanded>
          <AccordionItem key={field.fieldName}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <strong>{field.fieldTitle.en}</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <RefFieldsOptionSelect
                selectedField={currentField}
                name={field.fieldName}
                value={selectedMapping[field.fieldName]}
                handleSelectedMapping={this.handleSelectedMappingForReferenceField}
                projectId={projectId}
                collections={home.collections}
                uniqueKeys={flattenObjectKeys}
                connectorType={connectorType}
              />
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      );
    } else {
      return (
        <div className="row my-2 td-align-middle px-3" key={field.fieldName}>
          <div className="col-md-4 col-lg-4 col-sm-4">{field.fieldTitle.en}</div>
          <div className="col-md-8 col-lg-8 col-sm-8">
            {this.createApiSelect(field.fieldName, flattenObjectKeys)}
          </div>
        </div>
      );
    }
  };

  showField = () => {
    const { selectedCollection } = this.state;
    const { connectorType } = this.props;
    const image = apiTypeImages[connectorType];

    if (selectedCollection) {
      const { fields } = selectedCollection ? selectedCollection : '';

      const refFields =
        fields && fields.filter((field) => BelongsToReferenceField.includes(field.type));
      const nonRefFields =
        fields && fields.filter((field) => !BelongsToReferenceField.includes(field.type));
      return (
        <div className="col-12">
          <div className="row px-3">
            <div className="col-md-4 col-lg-4 col-sm-4">
              <h5 className="border-bottom">
                <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;User's Fields
              </h5>
            </div>
            <div className="col-md-8 col-lg-8 col-sm-8">
              <h5 className="border-bottom" style={{ lineHeight: '1.75em' }}>
                {connectorType ? (
                  <img
                    src={require(`../../common/dataSource/img/${image}`)}
                    width="18"
                    height="18"
                    className="no-wh"
                    alt={
                      connectorType === REST_API ? 'REST API' : snakeCaseToTitleCase(connectorType)
                    }
                  />
                ) : (
                  <i className={`wb ${drapcodeIcon(REST_API)}`}></i>
                )}
                &nbsp;
                {connectorType
                  ? connectorType === REST_API
                    ? 'REST API'
                    : snakeCaseToTitleCase(connectorType)
                  : 'Response'}
                &nbsp;Fields
              </h5>
            </div>
          </div>
          {nonRefFields && nonRefFields.map((field) => this.filterAndShow(field))}
          {refFields && refFields.map((field) => this.filterAndShow(field))}
        </div>
      );
    } else {
      return '';
    }
  };

  render() {
    return (
      <>
        <div className="col-6">
          <div className="form-group">
            <CustomInputWithIcon icon="text">
              <input
                name="currentUserItemsPath"
                onChange={(e) => this.props.handleChange(e.target.name, e.target.value)}
                value={this.props.itemsPath}
                className="form-control form-control-sm"
                placeholder="Response Data Items Path (Optional)"
              />
            </CustomInputWithIcon>
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <CustomInputWithIcon icon="text">
              <input
                name="currentUserPrimaryKey"
                onChange={(e) => this.props.handleChange(e.target.name, e.target.value)}
                value={this.props.currentUserPrimaryKey}
                className="form-control form-control-sm"
                placeholder="Field to uniquely Identify User"
              />
            </CustomInputWithIcon>
          </div>
        </div>
        {this.showField()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReponseDataKeyMappingToUserField);
